import { useCallback, useEffect, useState } from "react";
import axios from "../api/axiosConfig";

// Phase 28f mini — pending-for-me approvals badge feed.
// Polls /api/approval-requests/pending-for-me every 60s.

export default function usePendingApprovals(pollMs = 60000) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/approval-requests/pending-for-me");
      const rows = res.data?.data || res.data || [];
      setCount(Array.isArray(rows) ? rows.length : 0);
    } catch {
      // silent — badge is best-effort
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    if (!pollMs) return undefined;
    const id = setInterval(load, pollMs);
    return () => clearInterval(id);
  }, [load, pollMs]);

  return { count, loading, refresh: load };
}
